module.exports = __webpack_public_path__ + "static/media/Inter-Bold-slnt=0.c73899df.ttf";